var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew271({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.15,9.1V5.38h.4V6.91H5.13V5.38h.41V9.1H5.13V7.35H3.55V9.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.77,9.1,6,5.38h.42l.46,2.44c0,.25.09.5.13.76l.14-.69.58-2.51h.49L8.6,7.27a11,11,0,0,1,.24,1.31q.06-.36.15-.81l.48-2.39h.41L9,9.1H8.65L8,6.27l-.1-.44c0,.16-.06.31-.09.44L7.17,9.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.24,5.38h.4V7.53a3.12,3.12,0,0,1-.11.89,1,1,0,0,1-.38.54,1.12,1.12,0,0,1-.7.2,1.14,1.14,0,0,1-.91-.35,2.07,2.07,0,0,1-.3-1.28V5.38h.4V7.53a2.48,2.48,0,0,0,.08.73A.69.69,0,0,0,11,8.6a.78.78,0,0,0,.44.12A.76.76,0,0,0,12,8.48a1.61,1.61,0,0,0,.2-1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 7.97,
    cy: 7.31,
    r: 6.57
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.6,
    cy: 7.22,
    r: 1.37
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.4,
    cy: 7.22,
    r: 1.37
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 7.97,
    cy: 13.89,
    r: 1.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew271);
export default __webpack_public_path__ + "static/media/Symbolpack_New_271.63c60432b99e9a2bcfa2937d3314448d.svg";
export { ForwardRef as ReactComponent };